<template lang="pug">
  b-container.h-lg-100(fluid, :style="{padding: '0 !important'}")
    b-row.h-lg-100
      b-col.h-lg-100.overflow-lg-y#milestone-list(lg="4")
        b-container.px-0(fluid)
          b-card.chats(no-body)
            template(slot="header")
              .text-secondary.text-sm.mb-1 Selecciona rango de fechas:
              date-range-picker.w-100(:locale-data="{ firstDay: 1, format: 'D MMM YYYY', cancelLabel: 'Cancelar', applyLabel: 'Aceptar'}", v-model="date_range", :ranges="false", :linkedCalendars="false", showDropdowns, @update="dateChange")
            .milestones-rows
              h5.text-center.text-help.my-5(v-if="!parsed_milestones.length") No hay elementos que mostrar
              .milestone-row(v-for="(milestone, index) in parsed_milestones", :key="milestone.milestone_id", :selected="milestone.milestone_id == $route.params.milestone_id")
                .d-flex.flex-column.pointer(@click="$router.push({name: 'Milestone', params: { milestone_id: milestone.milestone_id } })")
                  .d-flex.mb-2.justify-content-between.align-items-center.text-secondary
                    div
                      .mr-2.icon-sm(:is="milestone.status_icon")
                      span.text-truncate.text-uppercase.text-sm {{ milestone._status }}
                    span.text-sm.text-nowrap {{ milestone.date }}
                  .d-flex.align-items-center
                    span.text-truncate {{milestone.title}}
                  .d-flex.align-items-center.mt-1
                    b-badge.mb-1.opacity-70(:style="{'background-color': milestone.type_color, color: BWTextColor(milestone.type_color)}") {{ milestone._type }}
        .d-flex.align-items-center.justify-content-center(style="min-height:48px;")
          b-spinner.mb-3(type="grow", variant="primary", v-if="loading_milestones")
      b-col.h-lg-100.d-none.d-lg-block(lg="8")
        b-card.card-inactive.text-center(v-if="!$route.params.milestone_id")
          EmptyMessage(message="Selecciona una milestone")
        router-view(v-if="$breakpoint.lgUp", :milestones="parsed_milestones")
    SideModal(v-model="side_modal_milestone", size="lg", @input="!$event ? $router.push({name: 'Roadmap'}) : false")
      template(v-if="side_modal_milestone")
        router-view.full-height(:milestones="parsed_milestones")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { BWTextColor } from '../../helpers/contrast-color-generator'
const milestoneController = createNamespacedHelpers('milestone')

export default {
  data () {
    return {
      loading_milestones: false,
      side_modal_milestone: false,
      selected_milestone: null,
      status: [
        {title: 'Pendiente', value: 'on_hold', icon: 'clock-icon'},
        {title: 'Agendado', value: 'shedule', icon: 'calendar-icon'},
        {title: 'Liberado', value: 'released', icon: 'check-circle-icon'},
      ],
      types: [
        {title: 'Mejora', value: 'improvement', color: '#007bff'},
        {title: 'Novedad', value: 'feature', color: '#20c997'},
        {title: 'Corrección', value: 'fix', color: '#ffdf5f'},
        {title: 'Hotfix', value: 'hotfix', color: '#ffa95f'},
        {title: 'Descontinuado', value: 'deprecated', color: '#e63757'},
      ],
      date_range: {
        startDate: '',
        endDate: ''
      },
    }
  },
  computed: {
    ...milestoneController.mapState({
      milestones: state => state.milestones
    }),
    parsed_milestones () {
      return this.milestones.map(m => {
        m.date = this.$moment(m.published_date).isValid() ? this.$moment(m.published_date).format('DD MMM') : 'Fecha por definir';

        let status = this.status.find(s => s.value === m.status)
        m._status = status ? status.title : 'Pendiente';
        m.status_icon = status ? status.icon : 'clock-icon';

        let type = this.types.find(t => t.value === m.type)
        m._type = type ? type.title : ''
        m.type_color = type ? type.color : '#edf2f9'

        return m
      })
    }
  },
  methods: {
    ...mapActions(['milestone/all', 'milestone/get']),
    BWTextColor: BWTextColor,
    getMilestones () {
      let self = this
      this.loading_milestones = true
      this.showLoadingScreen()

      this['milestone/all']({
        params: {
          ...self.paginationParams,
        },
        callback: res => {
          self.loading_milestones = false
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parseResponseForPaginationData(res)
          }
        }
      })
    },
    dateChange (data) {
      console.log(data)
    }
  },
  mounted () {
    let self = this
    var scrollFunction = function () {
      let top = $(this).scrollTop()

      if (top + this.clientHeight >= this.scrollHeight && self.pagination_hasNextPage) {
        self.getMilestones()
      }
    }

    $('#milestone-list').on('scroll', scrollFunction)
    $('#router-container').on('scroll', scrollFunction)

    this.getMilestones()
    this.date_range.startDate = this.$moment().subtract(1, 'days');
    this.date_range.endDate = this.$moment()
  },
  watch: {
    /*'$breakpoint' (value) {
      if (value.lgUp) {
        this.side_modal_milestone = false
      }
      if (value.mdDown && this.$route.name == 'Milestone') {
        this.side_modal_milestone = true
      }
    },*/
    '$route' (value) {
      this.side_modal_milestone = !!(value.name == 'Milestone' && value.params.milestone_id && this.$breakpoint.mdDown)
      this.selected_milestone = value.params.milestone_id ? (this.milestones.find(m => m.milestone_id == value.params.milestone_id) || null) : null
    }
  }
}
</script>

<style lang="scss" scoped>

  .milestone-row {
    width: 100%;
    padding: 0.75rem 1.25rem;
    transition: 0.5s;
    border-right: 2px solid transparent;

    &:not(:first-child) {
      border-top: 1px solid #edf2f9;
    }

    &:hover {
      background-color: var(--light);
    }

    &[selected] {
      border-right: 2px solid #0e5ccf;
      background-color: rgba(14, 92, 207, 0.1);
    }
  }

</style>
